export default "__VITE_ASSET__BZk8HxrO__"